import { render, staticRenderFns } from "./InfoautoCustomerOrders.vue?vue&type=template&id=b5ab0658&scoped=true"
import script from "./InfoautoCustomerOrders.vue?vue&type=script&lang=js"
export * from "./InfoautoCustomerOrders.vue?vue&type=script&lang=js"
import style0 from "./InfoautoCustomerOrders.vue?vue&type=style&index=0&id=b5ab0658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ab0658",
  null
  
)

export default component.exports